import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit'


import userSlice from './userDetails/userSlice'
import createFormSlice from './Form/FormSlice'
import ViewFormSlice from './Form/ViewForm'
import AllFormSlice from './Form/AllForm'
import ViewResponsesSlice from './Form/ViewResponses'
import ViewMyFormSlice from './Form/ViewMyForm'
import ViewMySubmissionSlice from './Form/ViewMySubmission'
import GetTeamsSlice from './Teams/getTeams'
import AssignFormSlice from './Form/AssignForm'
import SubmitFormSlice from './Form/SubmitForm'
import GetEmpIdSlice from './Teams/getEmpId'
import teamSlice from './userDetails/teamSlice'
import  AnalyticsFormSlice  from './Form/Analytics'
import  RecurringAssignFormSlice  from './Form/RecurringAssign'

export const store = configureStore({
    reducer: {
        user: userSlice,
        form: createFormSlice,
        view: ViewFormSlice,
        All: AllFormSlice,
        viewResponses: ViewResponsesSlice,
        ViewMyForm: ViewMyFormSlice,
        ViewMySubmission: ViewMySubmissionSlice,
        GetTeams: GetTeamsSlice,
        AssignSlice: AssignFormSlice,
        SubmitSlice: SubmitFormSlice,
        GetEmpId: GetEmpIdSlice,
        teams: teamSlice,
        RecurringAssignSlice:RecurringAssignFormSlice,
        AnalyticsSlice:AnalyticsFormSlice
    },
    middleware: [
        ...getDefaultMiddleware({
            serializableCheck: false
        }),
    ]
})